import React from 'react';
import PropTypes from "prop-types";

export class LegacyContextInjector extends React.Component {

  static childContextTypes = {
    t: PropTypes.func.isRequired,
    p: PropTypes.object.isRequired,
    logged_in_as: PropTypes.string,
    gatewayName: PropTypes.string,
    lanAddress: PropTypes.string,
    version: PropTypes.string,
  }

  getChildContext() {
    const { t, p, loggedInAs, gatewayName, lanAddress, version } = this.props;
    return {
      "t": t,
      "p": p,
      "logged_in_as": loggedInAs,
      "gatewayName": gatewayName,
      "lanAddress": lanAddress,
      "version": version,
    };
  }

  render() {
    return this.props.children;
  }
}